<script lang="ts" setup>
import { Autoplay, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { useAnnouncementStore } from '~/stores/announcement';
const store = useAnnouncementStore();

const localePath = useLocalePath();
const { locale } = useI18n();

const announcements = computed(() => {
  return store.data?.announcements?.length > 0 ? store.data?.announcements : [{ title: store.data?.announcement }];
});
</script>

<template>
  <div
    v-if="announcements.length > 0"
    class="bg-primary text-primary-foreground p-2 text-sm"
  >
    <div class="mx-auto w-full relative">
      <Swiper
        :modules="[Navigation, Autoplay]"
        :slides-per-view="1"
        :navigation="{
          nextEl: '.swiper-button-next-custom',
          prevEl: '.swiper-button-prev-custom',
        }"
        :loop="true"
        :autoplay="{
          delay: 3000,
          disableOnInteraction: false,
        }"
        :speed="1000"
      >
        <SwiperSlide v-for="announcement in announcements" :key="announcement.title">
          <div class="w-full mx-auto flex items-center justify-center">
            <NuxtLink
              v-if="announcement.callToAction?.element"
              :to="localePath('/' + announcement.callToAction.element.slug)"
              class="hover:underline"
            >
              {{ announcement.title }}
            </NuxtLink>
            <NuxtLink
              v-else-if="announcement.callToAction?.url"
              :to="announcement.callToAction.url"
              :target="announcement.callToAction.target || '_self'"
              class="hover:underline"
              :external="true"
            >
              {{ announcement.title }}
            </NuxtLink>
            <span v-else>
              {{ announcement.title }}
            </span>
          </div>
        </SwiperSlide>
      </Swiper>

      <!-- Custom navigation buttons -->
      <div class="swiper-button-prev-custom absolute left-2 top-1/2 transform -translate-y-1/2 z-10 cursor-pointer text-white hover:text-gray-200">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <div class="swiper-button-next-custom absolute right-2 top-1/2 transform -translate-y-1/2 z-10 cursor-pointer text-white hover:text-gray-200">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  </div>
</template>
